import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;

import { MathEnabledTextComponent, AppModal, getSize, getColor } from '@lib/common';
import { QuestionType } from '@module/form';
import styled, { getShadow } from '@xstyled/styled-components';
import { Space } from 'antd';
import { useCallback, useMemo } from 'react';
import { useQuestionContext } from '../core';
import { CardActions } from '../../shared';
import { QuestionAudioComponent, QuestionDescriptionComponent } from './common';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var StyledLayout = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n\n  position: relative;\n  box-shadow: ", ";\n  background-color: ", ";\n  padding: ", ";\n  border-radius: ", ";\n  overflow: hidden;\n\n  border-width: 1px 1px 1px 6px;\n  border-style: solid;\n  border-color: ", ";\n\n  transition: border-color 0.3s ease;\n"])), getSize('padding16'), getShadow('shadow1'), getColor('fillBgWhite'), getSize('padding24'), getSize('radiusSm'), function (_ref) {
  var $selected = _ref.$selected;
  return $selected ? getColor('fillIntActive') : '#cbd5e1';
});
var StyledQuestionHeader = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  width: 100%;\n"])));
var StyledQuestionNumberTag = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: ", " ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  background: #dbeafe;\n  border-radius: ", ";\n  font-weight: 700;\n  text-transform: uppercase;\n  flex-shrink: 0;\n  user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  -o-user-select: none;\n"])), getSize('padding2'), getSize('padding8'), getSize('typo12'), getSize('typo16'), getColor('fillIntActive'), getSize('radiusS'));
var StyledQuestionScoreTag = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: flex-start;\n\n  gap: ", ";\n\n  font-size: ", ";\n  font-weight: 600;\n  color: #728096;\n  border-radius: 999px;\n  border: 1px solid #e5e7eb;\n  padding: 6px ", ";\n  line-height: 1rem;\n"])), getSize('padding8'), getSize('typo14'), getSize('padding8'));
var StyledQuestionTypeTag = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: flex-start;\n\n  gap: ", ";\n\n  font-size: ", ";\n  font-weight: 600;\n  color: #728096;\n  border-radius: 999px;\n  border: 1px solid #e5e7eb;\n  padding: 6px ", ";\n  line-height: 1rem;\n"])), getSize('padding8'), getSize('typo14'), getSize('padding8'));
var StyledQuestionDescriptionWrapper = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral([""])));
var StyledExplanationWrapper = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: ", ";\n\n  width: 100%;\n  padding: ", ";\n  background-color: #faf8fc;\n  border-radius: ", ";\n  border: 1px solid #e2e8f0;\n"])), getSize('padding4'), getSize('padding12'), getSize('radiusSm'));
var StyledExplanationIconWrapper = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: ", ";\n  height: ", ";\n  flex-shrink: 0;\n"])), getSize('padding24'), getSize('padding24'));
var StyledExplanationTitle = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 700;\n  color: #1e293b;\n  line-height: 1.5;\n"])), getSize('typo16'));
var StyledExplanationContent = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n"])), getSize('padding4'));
var StyledExplanationDescription = styled(MathEnabledTextComponent)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: ", ";\n  letter-spacing: 0;\n  line-height: 1.6;\n  /* Set default color only for elements without inline styles */\n  color: #475569;\n\n  /* Preserve inline styles - inline styles have higher specificity */\n  /* Elements with inline styles will use their inline color */\n\n  img {\n    max-width: 100%;\n    border-radius: ", ";\n    margin: ", " 0;\n  }\n\n  strong {\n    font-weight: 600;\n    /* Only apply default color if no inline style */\n    &:not([style*='color']) {\n      color: #1e293b;\n    }\n  }\n\n  /* Preserve color for elements with inline styles */\n  span[style*='color'],\n  p[style*='color'],\n  div[style*='color'],\n  strong[style*='color'],\n  em[style*='color'],\n  u[style*='color'] {\n    /* Inline color will take precedence due to inline style specificity */\n  }\n\n  a {\n    color: ", ";\n    text-decoration: underline;\n\n    &:hover {\n      color: #6d28d9;\n    }\n  }\n"])), getSize('typo14'), getSize('radiusSm'), getSize('padding12'), getColor('fillIntActive'));
var StyledChildrenWrapper = styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral([""]))); // Helper function to check if explanation is empty (after removing HTML tags and whitespace)

var isExplanationEmpty = function isExplanationEmpty(explanation) {
  if (!explanation) return true; // Trim whitespace first

  var trimmedExplanation = explanation.trim();
  if (!trimmedExplanation) return true; // Check if explanation has images

  var hasImage = /<img[^>]+>/gi.test(trimmedExplanation);
  if (hasImage) return false; // Not empty if has image
  // Remove all whitespace

  var contentWithoutWhitespace = trimmedExplanation.replace(/\s/g, ''); // Remove all HTML tags

  var htmlTagRegex = /(<([^>]+)>)/gi;
  var formattedContentWithoutHTML = contentWithoutWhitespace.replaceAll(htmlTagRegex, ''); // Check if content is empty after removing HTML and whitespace

  return !formattedContentWithoutHTML || formattedContentWithoutHTML.length === 0;
};

export var BaseQuestionPreviewComponent = function BaseQuestionPreviewComponent(_ref2) {
  var _question$audioFile;

  var states = _ref2.states,
      actions = _ref2.actions,
      children = _ref2.children;
  var isSelected = states.isSelected,
      label = states.label,
      icon = states.icon,
      customDescription = states.customDescription,
      isEditable = states.isEditable,
      hideExplanation = states.hideExplanation,
      readonly = states.readonly,
      isAiMode = states.isAiMode,
      audioPlayerLabels = states.audioPlayerLabels;
  var onDeleteQuestion = actions.onDeleteQuestion,
      onEditRequest = actions.onEditRequest,
      onSelectQuestion = actions.onSelectQuestion,
      _onMention = actions.onMention;

  var _useQuestionContext = useQuestionContext(),
      question = _useQuestionContext.question; // Check if explanation is empty


  var hasExplanation = useMemo(function () {
    return !isExplanationEmpty(question.explanation);
  }, [question.explanation]);
  var questionTypeTagLabel = useMemo(function () {
    var _questionTypeTagLabel;

    var questionTypeTagLabelMapping = (_questionTypeTagLabel = {}, _defineProperty(_questionTypeTagLabel, QuestionType.SingleChoice, (label === null || label === void 0 ? void 0 : label.singleChoice) || ''), _defineProperty(_questionTypeTagLabel, QuestionType.FillInBlank, (label === null || label === void 0 ? void 0 : label.fillInBlank) || ''), _defineProperty(_questionTypeTagLabel, QuestionType.Matching, (label === null || label === void 0 ? void 0 : label.matching) || ''), _defineProperty(_questionTypeTagLabel, QuestionType.Essay, (label === null || label === void 0 ? void 0 : label.essay) || ''), _defineProperty(_questionTypeTagLabel, QuestionType.MultipleChoice, (label === null || label === void 0 ? void 0 : label.multipleChoice) || ''), _defineProperty(_questionTypeTagLabel, QuestionType.Speaking, (label === null || label === void 0 ? void 0 : label.speaking) || 'Speaking'), _questionTypeTagLabel);
    return questionTypeTagLabelMapping[question.type] || 'Unknown';
  }, [question.type, label]);
  var handleDeleteQuestion = useCallback(function () {
    AppModal.confirm({
      title: label.confirmDeleteQuestion,
      content: label.doYouWantToContinueDoingThis,
      okText: label.confirm,
      cancelText: label.cancel,
      onOk: function onOk() {
        onDeleteQuestion(question.id.toString());
      }
    });
  }, [label, onDeleteQuestion, question]);
  var jsonAudioFile = question === null || question === void 0 ? void 0 : (_question$audioFile = question.audioFile) === null || _question$audioFile === void 0 ? void 0 : _question$audioFile.toJsonObject();
  return /*#__PURE__*/_jsxs(StyledLayout, {
    id: "form-".concat(question.id.toString()),
    $selected: isSelected,
    onClick: function onClick() {
      return onSelectQuestion(question.id.toString());
    },
    children: [/*#__PURE__*/_jsxs(StyledQuestionHeader, {
      children: [/*#__PURE__*/_jsxs(Space, {
        size: 12,
        children: [/*#__PURE__*/_jsxs(StyledQuestionNumberTag, {
          children: [label.question, " ", question.titleIndex]
        }), /*#__PURE__*/_jsxs(StyledQuestionScoreTag, {
          children: [icon.star, /*#__PURE__*/_jsxs("span", {
            children: [question.score, " ", label.score]
          })]
        }), /*#__PURE__*/_jsxs(StyledQuestionTypeTag, {
          children: [icon.pointFocus, /*#__PURE__*/_jsx("span", {
            children: questionTypeTagLabel
          })]
        })]
      }), isEditable && /*#__PURE__*/_jsx(CardActions, {
        actions: ['edit', 'mention', 'delete'],
        onEdit: function onEdit(e) {
          e === null || e === void 0 ? void 0 : e.stopPropagation();
          onEditRequest(question.id.toString());
        },
        onMention: function onMention(e) {
          e === null || e === void 0 ? void 0 : e.stopPropagation();
          _onMention === null || _onMention === void 0 ? void 0 : _onMention();
        },
        onDelete: function onDelete(e) {
          e === null || e === void 0 ? void 0 : e.stopPropagation();
          handleDeleteQuestion();
        },
        sectionId: question.id.toString(),
        isAiMode: isAiMode
      })]
    }), /*#__PURE__*/_jsx(QuestionAudioComponent, {
      audioFile: question === null || question === void 0 ? void 0 : question.audioFile,
      questionId: question === null || question === void 0 ? void 0 : question.id,
      label: (label === null || label === void 0 ? void 0 : label.audio) || 'Âm Thanh',
      audioPlayerLabels: audioPlayerLabels
    }), /*#__PURE__*/_jsx(StyledQuestionDescriptionWrapper, {
      children: customDescription ? customDescription : /*#__PURE__*/_jsx(QuestionDescriptionComponent, {
        description: question.description,
        label: label,
        isShowingExtendOrCollapse: !isEditable
      })
    }), children && /*#__PURE__*/_jsx(StyledChildrenWrapper, {
      children: children
    }), !hideExplanation && hasExplanation && /*#__PURE__*/_jsxs(StyledExplanationWrapper, {
      children: [/*#__PURE__*/_jsx(StyledExplanationIconWrapper, {
        children: icon.lightBulb
      }), /*#__PURE__*/_jsxs(StyledExplanationContent, {
        children: [/*#__PURE__*/_jsx(StyledExplanationTitle, {
          children: label.explanation
        }), /*#__PURE__*/_jsx(StyledExplanationDescription, {
          value: question.explanation
        })]
      })]
    })]
  });
};